<template>
  <div id="app">
    <div class="page-container">
      <header-bar></header-bar>

      <nav-bar v-if="this.$route.path !== '/login' && this.$route.path !== '/logout' && loggedIn"></nav-bar>      

      <transition name="router-animation" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
        <router-view/>
      </transition>
    </div>

    <footer class="page-footer">
      <div class="footer-copyright text-center">TEmeter</div>
    </footer>
    <overlay :enabled="loading"></overlay>
  </div>
</template>

<script>
  import HeaderBar from '@/layouts/Header.vue'
  import NavBar from '@/layouts/Navbar.vue'
  import Overlay from '@/components/Overlay.vue';
  import { mapGetters } from 'vuex'

  export default {
  
  components: {HeaderBar, NavBar, Overlay},

  computed: {
    ...mapGetters([
      'loggedIn',
      'loading'
    ])
  }
}
</script>

<style lang="scss">
  @import url("https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css");

  .animated {
    -webkit-animation-duration: 0.3s;
    animation-duration: 0.3s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }
</style>